import cx from "classnames";
import React from "react";
import { FormattedHTMLMessage } from "react-intl";
import { Paragraph } from "@trainline/depot-web";
import IconArrowSwap from "../../assets/icons/IconArrowSwap";
import IconLondonTransport from "../../assets/icons/IconLondonTransport";
import IconWalk from "../../assets/icons/IconWalk";
import useDisplayOptions from "../../hooks/useDisplayOptions";
import useJourneyLeg from "../../hooks/useJourneyLeg";
import isTransferLeg from "../../utils/legs/isTransferLeg";
import LegHeader from "../TransitLeg/components/LegHeader";
import * as s from "./TransferLeg.module.css";
const IconTransferLeg = ({ type }) => {
  switch (type) {
    case "rapidTransit":
    case "underground":
    case "tube":
      return /* @__PURE__ */ React.createElement(IconLondonTransport, {
        className: cx(s.icon, s.iconTube)
      });
    case "walk":
      return /* @__PURE__ */ React.createElement(IconWalk, {
        className: s.icon
      });
    case "transfer":
      return /* @__PURE__ */ React.createElement(IconArrowSwap, {
        className: cx(s.icon, s.iconTransfer)
      });
    default:
      return null;
  }
};
const TransferLeg = ({ legId }) => {
  var _a, _b, _c;
  const leg = useJourneyLeg(legId);
  const { cardStyleLegs } = useDisplayOptions();
  if (!isTransferLeg(leg)) {
    return null;
  }
  const { legNumber } = leg;
  const origin = (_a = leg.origin) == null ? void 0 : _a.name;
  const destination = (_b = leg.destination) == null ? void 0 : _b.name;
  const transportType = leg.transportModeName || ((_c = leg.transportMode) == null ? void 0 : _c.mode);
  const hasHeader = !!legNumber;
  const isTransportTypeHandled = [
    "rapidTransit",
    "tube",
    "train",
    "underground",
    "walk",
    "transfer"
  ].includes(transportType);
  const messageId = `transferLeg.transferMessage.${transportType}`;
  return isTransportTypeHandled ? /* @__PURE__ */ React.createElement(React.Fragment, null, legNumber && /* @__PURE__ */ React.createElement(LegHeader, {
    legId
  }), /* @__PURE__ */ React.createElement("div", {
    className: cx(s.transferLeg, { [s.cardBody]: cardStyleLegs, [s.hasHeader]: hasHeader }),
    "data-testid": "transfer-leg-body"
  }, /* @__PURE__ */ React.createElement(IconTransferLeg, {
    type: transportType
  }), /* @__PURE__ */ React.createElement(Paragraph, {
    as: "span",
    typeStyle: "body"
  }, /* @__PURE__ */ React.createElement(FormattedHTMLMessage, {
    id: messageId,
    values: { origin, destination }
  })))) : null;
};
var TransferLeg_default = TransferLeg;
export {
  TransferLeg_default as default
};
